import { gql } from "@apollo/client";

import AssessmentNominationFragment from "@apps/assessments/graphql/assessment-nomination-fragment";

// The nominations the reader may pick for one person in one review. Empty when the reader
// may not, or when the review is not open for nominations.
export default gql`
  ${AssessmentNominationFragment}
  query getAssessmentOpenForNomination(
    $complianceProgramId: Int!
    $targetId: Int!
  ) {
    assessmentsOpenForNominations(
      complianceProgramId: $complianceProgramId
      targetId: $targetId
    ) {
      edges {
        node {
          ...AssessmentNomination
        }
      }
    }
  }
`;
